import React from 'react';

function Footer(props){
  return(
    <div className="w-100 text-center bg-dark p-5 my-1" style={{minHeight:'12vh'}}>
      <small className="text-white fw-light">PIXA SEARCH App © {new Date().getFullYear()}</small>
    </div>
  )
}

export default Footer